<template>
  <div class="row">
    <div class="row justify-content-center col-12">
      <va-button @click="openFileInput">{{ $t('checkup_plus.person.measurements.create.importar_xml') }}</va-button>
      <input type="file" accept=".xml" ref="fileInput" style="display: none" @change="handleFileChange"/>
    </div>
    <div v-if="parsedData" class="row col-12">
      <div class="col-12">
        <h5> {{ $t('checkup_plus.person.measurements.create.data_to_insert') }}</h5>

        <label v-if="this.momentCreationDate" class="is-bold">{{ `${$t('users.inputs.created_at')}: ${this.momentCreationDate.format('YYYY-MM-DD hh:mm')}`}}</label>
      </div>
      <div class="row col-12 mt-2">
        <h6 class="mt-2">{{ $t('checkup_plus.person.measurements.create.measurements_title') }}</h6>
        <div class="col-12">
          <ProfileGraph :measurement="measurement"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import xml2js from 'xml2js';
import moment from "moment";
import Table from "@/components/checkup_plus/patients/ParametersDetails/Mapa24/Table.vue";
import ProfileGraph from "@/components/checkup_plus/patients/ParametersDetails/ProfileGraph.vue";

const MAPA_24H_SYSTOLE_TYPE_ID = 62
const MAPA_24H_DIASTOLE_TYPE_ID = 63
const MAPA_24H_PULSE_TYPE_ID = 64
const MAPA_24H_TYPE_TYPE_ID = 65
const MAPA_24H_MAP_TYPE_ID = 66
const MAPA_24H_EVENT_TYPE_ID = 67
const MAPA_24H_ERROR_TYPE_ID = 68

export default {
  props: {
    // Declare a prop for the form data
    measurement: {
      type: Object,
      required: true,
    },
  },
  components: {ProfileGraph, Table},
  data() {
    return {
      parsedData: null,
      momentCreationDate: null,
    }
  },
  methods: {
    openFileInput() {
      this.$refs.fileInput.click();
    },
    handleFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.readFile(file)
      }
    },
    readFile(file) {
      //WHenever the file is read, update the base data:
      this.$emit('updateCanSubmit', false)
      this.measurement.measurementTypeId = 20
      this.measurement.measurementSeries = [
        {
          acquisitionRate: 600000,
          typeId: MAPA_24H_DIASTOLE_TYPE_ID,
          code: 'mapa_24h_diastole',
          measurementType: {
            name: 'MAPA_24H_DIASTOLE',
            id: MAPA_24H_DIASTOLE_TYPE_ID
          },
          measurementValues: []
        },
        {
          acquisitionRate: 600000,
          typeId: MAPA_24H_SYSTOLE_TYPE_ID,
          code: 'mapa_24h_systole',
          measurementType: {
            name: 'MAPA_24H_SYSTOLE',
            id: MAPA_24H_SYSTOLE_TYPE_ID
          },
          measurementValues: []
        },
        {
          acquisitionRate: 600000,
          typeId: MAPA_24H_PULSE_TYPE_ID,
          code: 'mapa_24h_pulse',
          measurementType: {
            name: 'MAPA_24H_PULSE',
            id: MAPA_24H_PULSE_TYPE_ID
          },
          measurementValues: []
        },
        {
          acquisitionRate: 600000,
          typeId: MAPA_24H_TYPE_TYPE_ID,
          code: 'mapa_24h_type',
          measurementType: {
            name: 'MAPA_24H_TYPE',
            id: MAPA_24H_TYPE_TYPE_ID
          },
          measurementValues: []
        },
        {
          acquisitionRate: 600000,
          typeId: MAPA_24H_MAP_TYPE_ID,
          code: 'mapa_24h_map',
          measurementType: {
            name: 'MAPA_24H_MAP',
            id: MAPA_24H_MAP_TYPE_ID
          },
          measurementValues: []
        },
        {
          acquisitionRate: 600000,
          typeId: MAPA_24H_EVENT_TYPE_ID,
          code: 'mapa_24h_event',
          measurementType: {
            name: 'MAPA_24H_EVENT',
            id: MAPA_24H_EVENT_TYPE_ID
          },
          measurementValues: []
        }
      ]

      const reader = new FileReader();
      reader.onload = () => {
        const xmlString = reader.result;
        this.parseXmlToJson(xmlString)
      }
      reader.readAsText(file)
    },
    parseXmlToJson(xmlString) {
      const parser = new xml2js.Parser();
      parser.parseString(xmlString, (err, result) => {
        if (err) {
          console.error(err);
        } else {
          this.parsedData = result

          this.momentCreationDate = moment(this.parsedData.BPTrackerLiteXML.Time_of_reading[0])
          this.measurement.date = this.momentCreationDate.unix()
          const measurementsXmlJson = this.parsedData.BPTrackerLiteXML.Measurements[0].Measurement
          if (measurementsXmlJson.length && measurementsXmlJson.length > 0) {
            this.parsedData.BPTrackerLiteXML.Measurements[0].Measurement.forEach(measurement => {
              if(measurement) {
                if(measurement.Diastole) {
                  const measSeries = this.measurement.measurementSeries.find(elem => elem.typeId === MAPA_24H_DIASTOLE_TYPE_ID)
                  if(measSeries) {
                    measSeries.measurementValues.push({
                      interval: moment(measurement.$.time).unix(),
                      value: measurement.Diastole[0]
                    })
                  }
                } if(measurement.Systole) {
                  const measSeries = this.measurement.measurementSeries.find(elem => elem.typeId === MAPA_24H_SYSTOLE_TYPE_ID)
                  if(measSeries) {
                    measSeries.measurementValues.push({
                      interval: moment(measurement.$.time).unix(),
                      value: measurement.Systole[0]
                    })
                  }
                } if(measurement.Pulse) {
                  const measSeries = this.measurement.measurementSeries.find(elem => elem.typeId === MAPA_24H_PULSE_TYPE_ID)
                  if(measSeries) {
                    measSeries.measurementValues.push({
                      interval: moment(measurement.$.time).unix(),
                      value: measurement.Pulse[0]
                    })
                  }
                } if(measurement.Type) {
                  const measSeries = this.measurement.measurementSeries.find(elem => elem.typeId === MAPA_24H_TYPE_TYPE_ID)
                  if(measSeries) {
                    measSeries.measurementValues.push({
                      interval: moment(measurement.$.time).unix(),
                      value: measurement.Type[0]
                    })
                  }
                } if(measurement.Type) {
                  const measSeries = this.measurement.measurementSeries.find(elem => elem.typeId === MAPA_24H_MAP_TYPE_ID)
                  if(measSeries) {
                    measSeries.measurementValues.push({
                      interval: moment(measurement.$.time).unix(),
                      value: measurement.MAP[0]
                    })
                  }
                } if(measurement.Event) {
                  const measSeries = this.measurement.measurementSeries.find(elem => elem.typeId === MAPA_24H_EVENT_TYPE_ID)
                  if(measSeries) {
                    measSeries.measurementValues.push({
                      interval: moment(measurement.$.time).unix(),
                      value: measurement.Event[0]
                    })
                  }
                }

                this.$emit('updateCanSubmit', true)
              }
            })
          }

        }
      });
    },
  }
}
</script>

<style scoped lang="scss">
th, td, table {
  border: 2px solid #000;
}
</style>
